export const header = {
	h1: `My invite link`,
	h2: `Copy`,
	h3: `Invitation address`,
	h4: `Bind address`,
	h5: `Ecology`,
	h6: `Share link`,
	h7: `Status`,
	h8: `Inactive`,
	h9: `Activated`,
	h10: `Home`,
	h11: `System announcement`,
	h12: `OIS price`,
	h13: `Share with friends`,
	h14: `Preaching Pool`,
	h15: `Mining power`,
	h16: `My Community`,
	h17: `Audit report`,
	h18: `Metaverse`,
	h19: `Game`,
	h20: `Copied`,
	h21: `confirm`,
	h22: `stay tuned`,
	h23: `Binding successful`,
	h24: `Binding relationship, please wait patiently for (5-10) seconds... `,
	h25: `ore pool`,
	h26: `My`,
	h27: "Pull down to refresh...",
	h28: "Release to refresh...",
	h29: "Loading...",
	h30: "There is no more!!",
	h31: "Set login password",
	h32: "Please enter the login password",
	h33: "Please confirm the login password",
	h34: "Login password",
	h35: "Reset login password",
	h36: "Set transaction password",
	h37: "Reset transaction password",
	h38: "Community node",
	h39: "Super node",
	h40: "Login succeeded",
	h41: "The login password cannot be blank",
	h42: "Confirm password cannot be blank",
	h43: "Please set a 6-digit alphanumeric + password",
	h44: "Please confirm your password",
	h45: `Login password error, please try again!!`,
	h46: `User does not exist`,
	h47: `forgot password`,
	h48: `Refresh successfully`,
	h49: `Binding failed, please check`,
	h51: `Please enter the correct binding address`,
	h52: `Change password`,
	h53: `Please enter a new password`,
	h54: `Please confirm the new password`,
	h55: `Please enter the Google verification code`,
	h56: `Confirm`,
	h57: `Google verification code error`,
	h58: `Please enter the login password`,
	h59: `Unbind Google verification`,
	h60: `Cash withdrawal succeeded, please wait for approval`,
	h61: `Transaction password error`,
	h62: `User does not exist`,
	h63: `User is not bound to Google authentication`,
	h64: `Claim successful`,
	h65: `User asset does not exist`,
	h66: `Insufficient webc assets`,
	h67: `Insufficient USDT assets`,
	h68: `Lottery`,
	h69: `The card does not exist`,
	h70: `successful pledge`,
	h71: `The number of cards is less than the number entered!! `,
	h72: `Transaction password error, please try again!! `,
	h73: `Please enter the number of cards or cards cannot be less than or equal to 0`
}
export const goodle = {
	"a0": "Binding Google Validation",
	"a1": "download APP",
	"a2": "Scan the QR code",
	"a3": "Backup key",
	"a4": "Binding Google Validation",
	"a5": "success",
	"a6": "Download and install the authentication APP",
	"a7": "Google validator",
	"a8": "How to use the Google authenticator",
	"a9": "next step",
	"a10": "Scan the QR code with the Google verification APP",
	"a11": "If you can't scan the QR code, please manually enter the string in the APP.",
	"a12": "The next step",
	"a13": "Backup the key in a secure location",
	"a14": "If you lose your phone, this key can be used to restore your authenticator,",
	"a15": "Customer service will take at least seven days to reset the Google validator.",
	"a16": "Need to verify your account before binding the Google validator",
	"a17": "Please enter a 6-bit verification code for the Google Validator",
	"a18": "Security validation is not available?",
	"a19": "The authenticator is already bound",
	"a20": "You have successfully bound the authenticator to protect your account",
	"a21": "return",
	"a22": "unbundle",
	"a23": "Are you sure you want to unbind Google Verfier?",
	"a24": "In order to protect your assets, the account will disthe payment service and C2C coins for 24 hours to ensure the security of your account.",
	"a25": "cancel",
	"a26": "confirm",
	"a27": "Unbind Google Verfier",
	"a28": "safety verification",
	"a29": "Google verification code",
	"a30": "Google Authenticator APP will protect your account and cash withdrawal function. ",
	"a31": "Change Google Authenticator"
}
export const card = {
	a1: "Balance",
	a2: "Recharge",
	a3: "Withdraw",
	a4: "My NFT",
	a5: "My SNFT",
	a6: "Lottery Draw Record",
	a7: "Draw a card",
	a8: "Unfortunately not winning!",
	a9: "Congratulations on winning!",
	a10: "Get",
	a11: "Reward",
	a12: "No data yet",
	a13: "Please enter the amount",
	a14: "Cancel",
	a15: "OK",
	a16: "Authorizing, please wait patiently for (5-10) seconds...",
	a17: "Enter password",
	a18: "Please enter password",
	a19: "Insufficient wallet balance, purchase failed",
	a20: "Congratulations on your synthesis",
	a21: "Unfortunately you did not win the prize",
	a22: "You have clicked the pop-up window continuously",
	a23: "Please",
	a24: "60 seconds",
	a25: "Open again later",
	a26: "You have reached the highest draw of the day",
	a27: "Get",
	a28: "Number of Blind Boxes",
	a29: "one",
	a30: "Refresh successfully",
	a31: "Please enter password",
	a32: "Please enter the amount",
	a33: "Authorization Quota Query",
	a34: "Contract Wallet Balance",
	a35: "Contract authorization",
	a36: "Insufficient contract balance",
	a37: "Pending block reaction",
	a38: "Please log in first",
	a39: "My Card",
	a40: "SNFT synthesis",
	a41: "Note: Only one UNFT can be selected for each SNFT",
	a42: "Zhang",
	a43: "Decompose",
	a44: "My SNFT",
	a45: "Synthetic Record",
	a46: "The synthesis mode that does not satisfy 9+1",
	a47: "Congratulations on synthesizing",
	a48: "Synthesize one",
	a49: "Please check the planet card",
	a50: "total",
	a51: "Congratulations",
}
export const orePond = {
	a1: "Mining Pool 1",
	a2: "Mining pool 2",
	a3: "Mining pool 3",
	a4: "Mining Pool 4",
	a5: "day",
	a6: "Profit",
	a7: "Computing Power",
	a8: "Available Quota",
	a9: "Deposit Amount",
	a10: "LP income",
	a11: "Pledge",
	a12: "Redemption",
	a13: "total",
	a14: "Zhang",
	a15: "Approved",
	a16: "Approved",
	a17: "Pledge Amount",
	a18: "Redeem Amount",
	a19: "Please enter the quantity",
	a20: "Enter password",
	a21: "Please enter password",
	a22: "Insufficient wallet balance, purchase failed",
	a23: "Get",
	a24: "Zhang",
	a25: "Card",
	a26: "Payment",
	a27: "Rules/Benefits",
	a28: "One star node",
	a29: "Two star node",
	a30: "Samsung Node",
	a31: "Please set the password first",
	a32: "My UNFT",
	a33: "Purchase",
	a34: "My",
	a35: "Gift Record",
	a36: "Rules/Benefits",
	a37: "Price",
	a38: "Destroyed amount of the whole network",
	a39: "Go mining",
	a40: "Card Mining",
	a41: "Consumption Mining",
	a42: "Not yet open",
	a43: "Purchase record",
	a44: "Limit",
	a45: "My WEBC",
	a46: "Node",
	a47: "piece",
	a48: "Limit purchase of 1 copy per address until sold out",
}
export const myself = {
	"a0": "Subscription",
	"a1": "My Assets",
	"a2": "My Community",
	"a3": "Invite Friends",
	"a4": "My Password",
	"a5": "My Transaction",
	"a6": "OTC transaction",
	"a7": "Strategic Partner",
	"a8": "Invite Friends",
	"a9": "Come and invite your friends to join",
	"a10": "My promotion code",
	"a11": "Transaction",
	"a12": "Purchase",
	"a13": "Sell",
	"a14": "Valuation",
	"a15": "Quantity",
	"a16": "Please enter the quantity",
	"a17": "Cancel",
	"a18": "OK",
	"a19": "Enter password",
	"a20": "Please enter password",
	"a21": "Insufficient wallet balance, purchase failed",
	"a22": "Please enter password",
	"a23": "Copy successful",
	"a24": "Please log in first",
	"a25": "My Assets",
	"a26": "Recharge",
	"a27": "Extract",
	"a28": "My NFT",
	"a29": "Galaxy NFT",
	"a30": "My SNFT",
	"a31": "My UNFT",
	"a32": "My Earnings",
	"a33": "Earnings WEBT",
	"a34": "Receive",
	"a35": "20% of the WEBC will be deducted when the balance is received",
	"a36": "Revenue Classification",
	"a37": "WEBT record",
	"a38": "Mining income",
	"a39": "Output WEBC:",
	"a40": "Balance",
	"a41": "My Community",
	"a42": "Community total performance USDT",
	"a43": "My level:",
	"a44": "Number of direct pushers:",
	"a45": "Direct push list",
	"a46": "Community member one",
	"a47": "Community member two",
	"a48": "Community member three",
	"a49": "My income",
	"a50": "Lottery Draw Proceeds",
	"a51": "Get",
	"a52": "Reward",
	"a53": "Share revenue",
	"a54": "My Password",
	"a55": "Set Password",
	"a56": "Reset Password",
	"a57": "Get signature",
	"a58": "Signature obtained",
	"a59": "Please enter the old password",
	"a60": "Please set a 6-digit alphanumeric payment password",
	"a61": "Please confirm your payment password",
	"a62": "Complete",
	"a63": "Acquisition succeeded",
	"a64": "Please get the signature first",
	"a65": "The two passwords entered are inconsistent",
	"a66": "Setting succeeded",
	"a67": "OTC transaction",
	"a68": "Purchase",
	"a69": "Sell",
	"a70": "Please select",
	"a71": "Valuation",
	"a72": "Quantity",
	"a73": "USDT Balance",
	"a74": "WEBC Balance",
	"a75": "Reminder: 1% WEBC of transaction fee",
	"a76": "Enter password",
	"a77": "Please enter password",
	"a78": "Insufficient wallet balance, purchase failed",
	"a79": "Please enter the quantity",
	"a80": "Please enter password",
	"a81": "Galaxy NFT",
	"a82": "Mercury",
	"a83": "A total of ten cards",
	"a84": "Mars",
	"a85": "Venus",
	"a86": "Saturn",
	"a87": "Jupiter",
	"a88": "My UNFT",
	"a89": "My income",
	"a90": "Lottery Draw Proceeds",
	"a91": "Get Jupiter reward",
	"a92": "Share revenue",
	"a93": "USDT record",
	"a94": "USDT share revenue",
	"a95": "Time",
	"a96": "Reward",
	"a97": "Address",
	"a98": "Source",
	"a99": "Share",
	"a100": "Deal in progress, please wait!",
	"a101": "Not enough available USDT! Cannot purchase!",
	"a102": "Not enough webc available! Cannot purchase!",
	"a103": "Not enough available Snft! Cannot sell!",
	"a104": "Not enough webc available! Cannot sell!",
	"a105": "Please wait patiently after purchase",
	"a106": "performance",
	"a107": "Please confirm the password"
}
export const home = {
	h1: `OIS total network computing power`,
	h2: `OIS total network destruction`,
	h3: `OIS daily maximum yield`,
	h4: `OIS total circulation`,
	h5: `LP pool`,
	h6: `(not yet open)`,
	h7: `Pledge mining`,
	h8: `Single currency pool`,
	h9: `combination pool`,
	h10: `Get OIS income`,
	h11: `Get USDT income`,
	h12: `Withdrawal`,
	h13: `Partner`,
	h14: `Oasis is a collection of DEFI, NET, Metaverse, Chain Games, etc`,
	h15: `Multiple Decentralized Platform`,
	h16: `350% capped reincarnation`
}
export const miningIncome = {
	m1: `Preaching Pool Mining Income`,
	m2: `Total output per day (OIS)`,
	m3: `Mission output (OIS)`,
	m4: `Personal power`,
	m5: `Mining income`,
	m6: `Share revenue (USDT)`,
	m7: `Share computing power`,
	m8: `Total amount of coins that can be withdrawn (USDT)`,
	m9: `Total number of coins that can be withdrawn (OIS)`,
	m10: `Withdraw OIS earnings`,
	m11: `Withdraw USDT earnings`,
	m12: `Hint`,
	m13: `Amount to extract:`,
	m14: `Extract`,
	m15: `Cancel`,
	m16: `Committed, please wait for block confirmation`,
}
export const pushStraight = {
	p1: `My direct push list`,
	p2: `Address`,
	p3: `No recommended address yet`,
	p4: `Recommended`,
	p5: ``,
	p6: `copy`,
	p7: `Direct push list of this address`,
	p8: `Confirm`,
}
export const vip = {
	v1: `My level`,
	v2: `Mining income`,
	v3: `VIP get`,
	v4: `always required`,
	v5: `Buy`,
	v6: `approval`,
	v7: `Description`,
	v8: `V5 will be capped and reincarnated, V6 will light up, V6 will be capped and reincarnated, and V7 will light up`,
	v9: `Cannot be less than or equal to the current level`,
	v10: `Committed, please wait for block confirmation`,
	v11: `Authorization, please wait for block confirmation`,
	v12: `Confirming, please wait`,
	v13: `Authorization successful`,
	v14: `Do not repeat purchase`,
	v16: `Authorization succeeded`,
	v17: `余额不足请充值`,
	v18: `钱包还在扣款请等待!!`,
	v19: `购买成功`,
	v20: `请耐心等待，区块链反应`,
	v21: `余额不足`
}
export const Kp = {
	a0: 'Transfer',
	a1: 'Flash',
	a2: 'Transfer record',
	a3: 'Time',
	a4: 'Address',
	a5: 'Quantity',
	a6: 'Please enter the collection address',
	a7: 'Please enter quantity',
	a8: 'Consumption',
	a9: 'Congratulations on your winning NFT',
	a10: 'SNFT extraction computing power',
	a11: 'USDT record',
	a12: 'Income USDT',
	a13: 'Lottery for SNFT computing Power',
	a14: " Address cannot be null or 0",
	a15: " The quantity cannot be empty or zero ",
	a16: " The recipient user does not exist/or the recipient is not a subordinate to itself!",
	a17: " Transfer successful ",
	a18: " Not enough money in my wallet ",
	a19: " The current user does not exist ",
	a20: " Transaction password error ",
	a21: " The transfer amount cannot be less than or equal to 0",
	a22: 'User has no corresponding SNFT',
	a23: 'Please enter address',
	a24: 'Please enter flash quantity',
	a25: 'The amount of flash exchange shall not be less than or equal to 0',
	a26: 'The user does not exist',
	a27: 'flash exchange successful',
	a28: 'Please enter your transaction password',
	a29: 'Transaction password error',
	a30: 'User does not have enough SNFT for flash exchange',
	a31: 'type',
	a32: 'Recipient user does not exist',
	a33: 'Galaxy SNFT',
	a34: 'Space SNFT',
	a35: 'Cosmic SNFT',
	a36: 'Available quantity',
	a37: 'Zhang',
	a38: 'Obtain',
	a39: 'Sure',
	a39: 'Confirm',
	a40: 'Historical records',
	a41: 'Recharge',
	a42: 'Draw money',
	a43: 'Transfer',
	a44: 'Flash',
	a45: 'Address1',
	a46: 'Address2',
	a47: 'Under application',
	a48: 'Approved',
	a49: 'Rejected for review',
	a50: 'currency',
	a51: 'Transfer record',
	a52: 'NFT Game ',
	a53: 'Acquired computational power',
	a54: 'times',
	a55: 'Genesis node',
	a56: 'in progress',
	a57: 'Finished',
	a58: 'Revocation',
	a59: 'For sale ',
	a60: 'Buy',
	a61: 'Bill of Sale',
	a62: 'Operation',
	a63: 'Direction',
	a64: `The amount of money`,
	a65: 'Waiting for the deal',
	a66: 'Partial sale',
	a67: 'All sold',
	a68: 'Cancel',
	a69: `Is the order cancelled?`,
	a70: 'Otc order does not exist',
	a71: 'All Otc orders have been completed or the number of transactions has reached zero',
	a72: 'otc order cancelled successfully',
	a73: "Ore Pool 1",
	a74: "Ore Pool 2",
	a75: "Ore Pool 3",
	a76: "Ore Pool 4",
	a77: "Destroy",
	a78: "This operation will go to the home page to extract the SNFT blind box Are you sure?",
	a79: "Pit 2 Network computing power",
	a80: "Pit 2 Net output",
	a81: "Pit 2 Personal computing power",
	a82: "Pit 2 Individual outpu",
	a83: "Extract",
	a84: "Extract quantity",
	a85: "Please enter quantity",
	a86: "Do not repeat the pledge ",
	a87: "In pledge please be patient for (5-10) seconds...",
	a88: "Authorization failure ",
	a89: "The pledge is successful ",
	a90: "Pledge failed, please check ",
	a91: "On-chain pledge failed ",
	a92: "The amount pledged cannot be less than zero or empty ",
	a93: "The amount pledged must be less than or equal to the available balance ",
	a94: "No redemption until time is up ",
	a95: "No redeemable, please pledge first ",
	a96: "The redemption quantity cannot be empty or zero ",
	a97: "The amount redeemed must be less than or equal to the amount deposited ",
	a98: "Do not click, only allow maximum redemption ",
	a99: "Redemption successful ",
	a100: "Redemption failed, please check ",
	a101: "On-chain call failed ",
	a102: "Being redeemed please wait (5-10) seconds...",
	a103: "Purchase successful ",
	a104: "Record ",
	a105: "USDT buys UNFT",
	a106: "UNFT downward Transfer - Receiver ",
	a107: "UNFT Down Transfer - Sender ",
	a108: "Please upgrade to V1 or above first",
	a109: "Mine Pool 1 Full network calculation Power ",
	a110: "Mine pool a whole network output ",
	a111: "One man in a mining pool ",
	a112: "Mine pool produced by one man ",
	a113: "SNFT destruction Extraction Computing Power ",
	a114: "Select Destroy Type",
	a115: "Select Blind Box Type",
	a116: "Computing Power of the Whole Network ",
	a117: "Output from the whole network ",
	a118: "Personal computing Power ",
	a119: "Individual output ",
	a120: "Only support pledge and redemption Max",
	a121: "Maximum extraction only supported ",
	a122: "WEBC Record",
	a123: "Purchase UNFT is not open",
	a124:" Frozen balance ",
	a125:" Available Balance ",
	a126:" Frozen Earnings ",
	a127:" Balance of calculation ",
	a128:" Classification"
}
export const flowType = {
	"a0": "Node subscription ",
	"a1": "recharge on the chain ",
	"a2": "background recharge ",
	"a3": "Draw cards - win the lottery ",
	"a4": "Draw cards - spend ",
	"a5": "Raffle Return -(no winning)",
	"a6": "Raffle Proceeds -(no winners)",
	"a7": "Promotion Award - Management Classification Award ",
	"a8": "Promotion Award - Direct Promotion Award ",
	"a9": "Card Composition - Consumption ",
	"a10": "Card Composition - Success ",
	"a11": "Node Subscription - Bonus ",
	"a12": "otc Purchase Order - deduct Usdt available ",
	"a13": "otc Purchase Orders - Increase Frozen Usdt",
	"a14": "otc Purchase Order - less handling charge ",
	"a15": "otc Transaction ",
	"a16": "otc Sale Order - Deductible available SNTF",
	"a17": "Order for otc Sale - less handling Fee ",
	"a18": "Collect my proceeds ",
	"a19": "User applies for withdrawal ",
	"a20": "Mine Pool No. 2 - Mining Income ",
	"a21": "Destroy the card to gain computing power ",
	"a22": "Withdrawal - Through ",
	"a23": "Withdrawal - Decline ",
	"a24": "Mine Pool No. 1 - Mining Income ",
	"a25": "UNFT downward Transfer - Recipient ",
	"a26": "UNFT downward Transfer - Sender ",
	"a27": "User conversion -WEBT conversion to USDT",
	"a28": "flash snft is WEBT",
	"a29": "Withdrawal of USDT- less WEBC handling fee ",
	"a30": "Withdraw WEBC- less WEBC handling fee ",
	"a31": "Card Composition - Handling Fee ",
	"a32": "USDT down Transfer - Receiver ",
	"a33": "USDT Transfer down - Sender ",
	"a34": "WEBC downward Transfer - Recipient ",
	"a35": "WEBC downward Transfer - Sender ",
	"a36": "User conversion -USDT conversion to WEBT",
	"a37": "Settlement income reduces computation power ",
	"a38": "WEBT downward Transfer - Recipient ",
	"a39": "WEBT downward Transfer - Sender ",
	"a40": "otc Cancelled Order ",
	"a41": "otc Cancellation of Sale Order - Refund Fee ",
	"a42": "otc Cancel Sale Order - Return SNFT",
	"a43": "Claim my Pool 1 income - Increase Assets ",
	"a44": "Claim my Pool II income - Increase Assets ",
	"a45": "Purchase UNFT using USDT ",
	"a46": "Destroy card ",
	"a47": "Pledge LP",
	"a48": "Pledge LP to obtain computing power ",
	"a49": "Claim my pool 1 revenue - Reduce output ",
	"a50": "Claim my Pool II revenue - Reduce Output"
}